import { all } from 'redux-saga/effects';

// sagas
import fetchMessagesSaga from './fetchMessagesSaga';
import createMessageSaga from './createMessageSaga';
import updateMessageSaga from './updateMessageSaga';
import deleteMessageSaga from './deleteMessageSaga';
import listenForMessagesSaga from './listenForMessagesSaga';

const messageSaga = function* rootSaga() {
  yield all([
    fetchMessagesSaga(),
    createMessageSaga(),
    updateMessageSaga(),
    deleteMessageSaga(),
    listenForMessagesSaga(),
  ]);
};

export default messageSaga;
